import { render, staticRenderFns } from "./Lgx335106580255080448.vue?vue&type=template&id=4de2182c&scoped=true&"
import script from "./Lgx335106580255080448.vue?vue&type=script&lang=js&"
export * from "./Lgx335106580255080448.vue?vue&type=script&lang=js&"
import style0 from "./Lgx335106580255080448.vue?vue&type=style&index=0&id=4de2182c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de2182c",
  null
  
)

export default component.exports